import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export interface Lead {
    id: number;
    name: string;
    email: string;
    phone: string;
    project: string;
    date: string;
    status: "NEW" | "READ" | "CONTACTED" | "CLOSED";
    message: string;
    notes?: string;
}

interface LeadsState {
    leads: Lead[];
}

const initialState: LeadsState = {
    leads: [
        { id: 1, name: "Amit Sharma", email: "amit.s@example.com", phone: "+91 98765 43210", project: "Luxury Home Theater", date: "2024-12-24", status: "NEW", message: "Looking for a high-end 7.1 setup." },
        { id: 2, name: "Riya Patel", email: "riya.p@webmail.com", phone: "+91 87654 32109", project: "Smart Lighting Control", date: "2024-12-23", status: "CONTACTED", message: "Need automation for my existing living room." },
        { id: 3, name: "John Doe", email: "j.doe@global.com", phone: "+91 91234 56789", project: "Distributed Audio", date: "2024-12-22", status: "READ", message: "Multi-room audio system for a restaurant." },
        { id: 4, name: "Priya Singh", email: "priya.singh@design.in", phone: "+91 99887 76655", project: "TV Mounting", date: "2024-12-21", status: "CLOSED", message: "Wall mount for 85-inch Sony TV." },
    ],
};

const leadsSlice = createSlice({
    name: "leads",
    initialState,
    reducers: {
        updateLeadStatus: (state, action: PayloadAction<{ id: number; status: Lead["status"]; notes?: string }>) => {
            const lead = state.leads.find((l) => l.id === action.payload.id);
            if (lead) {
                lead.status = action.payload.status;
                if (action.payload.notes !== undefined) {
                    lead.notes = action.payload.notes;
                }
            }
        },
    },
});

export const { updateLeadStatus } = leadsSlice.actions;
export default leadsSlice.reducer;
